export const contentConstants = {
    GETALL_REQUEST: 'CONTENT_GETALL_REQUEST',
    GETALL_SUCCESS: 'CONTENT_GETALL_SUCCESS',
    GETALL_FAILURE: 'CONTENT_GETALL_FAILURE',

    DELETE_REQUEST: 'CONTENT_DELETE_REQUEST',
    DELETE_SUCCESS: 'CONTENT_DELETE_SUCCESS',
    DELETE_FAILURE: 'CONTENT_DELETE_FAILURE'
};
